<template>
    <sections>
        <section-hero
            :image="hero.image"
            :imageSet="hero.imageSet"
            :imageSizes="hero.imageSizes"
            heading="Chuck & Lauren"
            content="<article-chuck-hero />"
        ></section-hero>
        <section-text
            color="bg-zinc-50"
            heading="About Chuck"
            headingComponent="h2"
            content="<article-chuck-about />"
        ></section-text>
        <section-text
            heading="Chalk & Cheese!"
            headingComponent="h2"
            content="<article-chuck-contact />"
            buttonText="Contact Lauren"
            buttonRoute="/contact"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const hero = {
    imageSizes: '(max-width: 1024px) 100vw, 1024px',
    imageSet: `
        ${$config.public.images}chuck-lauren-512.webp 512w,
        ${$config.public.images}chuck-lauren-841.webp 841w,
        ${$config.public.images}chuck-lauren-1024.webp 1024w
    `,
    image: `${$config.public.images}chuck-lauren.jpg`,
};

useSeo().buildHead({
    image: $config.public.images + 'chuck-lauren.jpg',
    title: 'Chuck Brown & Lauren Jones',
    description: 'They fit together like chalk and cheese.',
    index: true,
});
</script>
